export default __webpack_public_path__ + "static/media/closeButtonDocViewer.3f3ee2d8.svg";